export function detectDuplicateFilters(filters, keyField = 'shortName') {
  const seenKeys = new Set()
  const duplicates = []
  const uniqueFilters = []

  filters.forEach((filter, index) => {
    const baseKey = filter[keyField]?.toLowerCase?.() || filter[keyField]
    // Include type in key to allow same shortName with different types (e.g., Float_min vs Float_max)
    const key = filter.type ? `${baseKey}::${filter.type}` : baseKey

    if (seenKeys.has(key)) {
      duplicates.push({
        ...filter,
        originalIndex: index,
        duplicateKey: key
      })
    } else {
      seenKeys.add(key)
      uniqueFilters.push(filter)
    }
  })

  return {
    duplicates,
    uniqueFilters,
    seenKeys: Array.from(seenKeys),
    hasDuplicates: duplicates.length > 0
  }
}

export function logDuplicatesToSentry(duplicates, context = {}) {
  if (duplicates.length === 0) {
    return
  }

  // eslint-disable-next-line no-console
  console.warn(`Duplicate filters detected in ${context.location || 'unknown location'}:`, duplicates)
  try {
    const {$sentry} = useNuxtApp()

    if ($sentry) {
      const message = `Duplicate filters detected in ${context.location || 'application'} - Route:${context.route}`

      $sentry.captureMessage(message, {level: 'warning'})
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Could not log to Sentry: useNuxtApp not available', error)
  }
}

export function processFiltersWithDuplicateDetection(filters, context = {}) {
  const result = detectDuplicateFilters(filters)

  if (result.hasDuplicates) {
    logDuplicatesToSentry(result.duplicates, {
      ...context,
      totalFilters: filters.length,
      uniqueFilters: result.uniqueFilters.length
    })
  }

  return result.uniqueFilters
}
